import { DisplayableData } from './displayable.types'

export function getDisplayableLabel<T extends DisplayableData>({ display }: T) {
  return display.label
}

export function getDisplayableImage<T extends DisplayableData>({ display }: T) {
  return display.image
}

export function getDisplayableExtraInfo<T extends DisplayableData>({ display }: T) {
  return display.extraInfo
}

export function getDisplayableDescription<T extends DisplayableData>({ display }: T) {
  return display.description
}

export function getDisplayablePlaceholder<T extends DisplayableData>({ display }: T) {
  return display.placeholder
}
